"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { Suspense, useEffect } from "react";

import { ensureBackToPageCookie } from "../../helpers/backToPage.helper";

type Props = {
  cookieDomain: string;
};

function BackToPageTrackerInner({ cookieDomain }: Props) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    ensureBackToPageCookie(cookieDomain);
  }, [cookieDomain, pathname, searchParams]);

  return null;
}

// Suspense boundary keeps useSearchParams from forcing the whole route
// into client-side rendering at build time.
export function BackToPageTracker(props: Props) {
  return (
    <Suspense fallback={null}>
      <BackToPageTrackerInner {...props} />
    </Suspense>
  );
}
